import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	dialogPopup: {
		maxWidth: '650px',
		width: '90vw',
	},
	dialogBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		padding: THEME.spacing.lg,
	},
	dialogFooter: {
		display: 'flex',
		justifyContent: 'center',
		padding: '16px 24px 24px',
	},
	text: {
		paddingLeft: THEME.spacing.sm,
		fontSize: 14,
		lineHeight: '20px',
		maxWidth: 520,
		margin: 0,
	},
	ack: {
		display: 'flex',
		gap: 8,
	},
	ackLabel: {
		fontSize: 14,
		lineHeight: '20px',
		marginTop: -2,
	},
	link: {
		fontSize: 14,
	},
	acknowledgeButton: {
		minWidth: '150px',
	},
});
